module.exports = __webpack_public_path__ + "img/icon-3.37a319bc.png";